/*
Author: Jeewantha Madubashana Karunarathna
Date: 07/05/2025
Copyright © 2025 Infix!. All rights reserved.
*/

import { ReactNode, useEffect } from 'react';
import fetchIntercept, { FetchInterceptorResponse } from 'fetch-intercept';
import { useMsal } from "@azure/msal-react";
import { Session } from '@/utils';

export const ApiInterceptor = ({ children }: { children: ReactNode }) => {
const { instance } = useMsal();


useEffect(() => {
  const unregister = fetchIntercept.register({
    request: (url, config) => [url, config],
    response: (response: FetchInterceptorResponse) => {
      if (response.status === 401) {
        if(Session.getUserType() === 'poa'){
          Session.abandon();
          (async () => {
            try {
              await instance.logoutRedirect({postLogoutRedirectUri: "/home",});
            } catch (err) {
              console.log("Logout redirect failed for poa user", err);
            }
          })();
        }else{
          Session.abandon();
          window.location.href = '/home';
        }
        }
      return response;
    },

    responseError: (error) => {
      console.error("API error:", error);
      return Promise.reject(error);
    },
  });

  return () => unregister();
}, []);


  return <>{children}</>;
};